import * as PromoCode from './PromoCode/PromoCode.css';
import * as PromoCodeForm from './Form/PromoCodeForm.css';
import * as Field from './Form/Field/Field.css';

export default {
	PromoCode,
	PromoCodeForm,
	Field
};
